import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkOrdersService } from '../work-orders.service';
import { GLOBAL } from 'src/app/app.globals';

@Component({
  selector: 'app-work-order-details',
  templateUrl: './work-order-details.component.html',
  styleUrls: ['./work-order-details.component.css']
})
export class WorkOrderDetailsComponent implements OnInit {
  @Input() workOrderCode: string;
  @Input() requireType: number = 1; // 1: main Contractor | 0: Sub-Contractor
  @Output() closeModal = new EventEmitter<void>();

  workOrderDetails: any = {};
  showGrid = true;

  // Column definitions for grids
  eicUserColDefs = [
    { headerName: 'EIC Name', field: 'EIC', sortable: true, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Email ID', field: 'Email', sortable: true, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Priority', field: 'Priority', sortable: true, cellStyle: { 'text-align': 'center' } }
  ];

  documentColDefs = [
    { headerName: 'Document Name', field: 'DocumentName', sortable: true, width: 150, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Document Type', field: 'DocumentType', sortable: true, width: 120, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Uploaded By', field: 'UploadedBy', sortable: true, width: 120, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Size', field: 'Size', sortable: true, width: 80, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Uploaded Date', field: 'UploadedDate', sortable: true, width: 120, cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => params.value ? new Date(params.value).toLocaleDateString() : '-' },
    { headerName: 'Is Verify?', field: 'IsVerify', sortable: true, width: 90, cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => params.value ? 'Yes' : 'No' },
    { headerName: 'Verify Date', field: 'VerifyDate', sortable: true, width: 120, cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => params.value ? new Date(params.value).toLocaleDateString() : '-' },
    { headerName: 'Verify By', field: 'VerifyBy', sortable: true, width: 120, cellStyle: { 'text-align': 'center' } },
    { 
      headerName: 'View', 
      field: 'DocLink',
      sortable: false,
      width: 80,
      cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => {
        if (params.value) {
          return '<a href="' + GLOBAL.DOC_URL + params.value + '" target="_blank"><i class="fa fa-eye" style="cursor: pointer; color: #4fc5ea;"></i></a>';
        }
        return '-';
      }
    }
  ];

  companyPolicyColDefs = [
    { headerName: 'Policy No', field: 'ECPolicyNo', sortable: true },
    { headerName: 'Company Name', field: 'CompanyName', sortable: true },
    { headerName: 'Issue Date', field: 'IssueDate', sortable: true,
      cellRenderer: (params) => params.value ? new Date(params.value).toLocaleDateString() : '-' },
    { headerName: 'Max Person', field: 'InsurePerson', sortable: true }
  ];

  constructor(private workOrderService: WorkOrdersService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.workOrderCode) {
      this.getWorkOrderDetails();
    }
  }

  getWorkOrderDetails(): void {
    const workOrderCodeNum = parseInt(this.workOrderCode, 10);
    this.workOrderService.getWorkOrderDetailsNew(workOrderCodeNum, this.requireType).subscribe((response: any) => {
      if (response && response.Table1 && response.Table1.length > 0) {
        this.workOrderDetails = response.Table1[0];
        this.workOrderDetails.OrderOwnerUserAndPrioritys = response.Table2 || [];
        this.workOrderDetails.DocumentImageMasterViewModals = response.Table3 || [];
        console.log('Work Order Details:', this.workOrderDetails);
        console.log('Document Data (Table3):', response.Table3);
      }
    }, error => {
      console.error('Error fetching work order details:', error);
    });
  }

  onCloseAction(): void {
    this.activeModal.close();
  }
}